/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Receipt_VatInputs */

const vi_receipt_vat = /** @type {(inputs: Receipt_VatInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`VAT ${i?.percent}%`)
};

/**

* @param {Receipt_VatInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_vat = /** @type {((inputs: Receipt_VatInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_VatInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_vat(inputs)
});